import { useEffect, useState } from "react";
import Project from "../../components/developer/Project";
import TableBody from "../../components/TableBody";
import { useLocation, useParams } from "react-router-dom";
import FormatTime from "../../utils/FormatTime";
import ParseTime from "../../utils/ParseTime";
import TableFooter from "../../components/developer/TableFooter";

// Skeleton компонент для строки проекта
const ProjectRowSkeleton = () => (
  <div className="grid grid-cols-6 gap-4 items-center border-b py-2 animate-pulse">
    <div className="h-4 bg-gray-300 rounded w-24"></div>
    <div className="flex gap-2">
      <div className="h-8 bg-gray-300 rounded w-16"></div>
      <div className="h-8 bg-gray-300 rounded w-16"></div>
      <div className="h-8 bg-gray-300 rounded w-16"></div>
    </div>
    <div className="h-4 bg-gray-300 rounded w-20"></div>
    <div className="h-4 bg-gray-300 rounded w-20"></div>
    <div className="h-4 bg-gray-300 rounded w-20"></div>
    <div className="h-8 bg-gray-300 rounded w-16"></div>
  </div>
);

function Developers() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [timeTotal, setTimeTotal] = useState(0);
  const [alreadyPaid, setAlreadyPaid] = useState(0);

  const params = useParams();

  function countTotalTime(data) {
    let timeTotal = 0;
    data.forEach((item) => {
      timeTotal += ParseTime(item.properties.Time.rich_text[0]?.plain_text);
    });

    setTimeTotal(FormatTime(timeTotal));
  }
  function countAlreadyPaid(data) {
    let alreadyPaidTotal = 0;
    data.forEach((item) => {
      alreadyPaidTotal += ParseTime(
        item.properties.already_paid.rich_text[0]?.plain_text
      );
    });

    setAlreadyPaid(FormatTime(alreadyPaidTotal));
  }

  useEffect(() => {
    async function fetchf() {
      setLoading(true);
      try {
        const res = await fetch(
          "https://time-api.web-hub.online/api/projects-by-team?team_id=" +
            params.developer
        );
        const data = await res.json();

        setResults(data?.results || []);
        countTotalTime(data.results || []);
        countAlreadyPaid(data.results || []);
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchf();
  }, [params.developer]);

  return (
    <div className="overflow-auto w-full max-w-[1680px]">
      <div className=" min-w-[1000px] rounded-lg p-8">
        <TableBody
          className="grid-cols-[1fr_1fr_3fr_1fr]"
          header={
            <>
              <div>Project name</div>
              <div>Controlls</div>
              <div>Time</div>
              <div>History</div>
            </>
          }
        >
          {loading ? (
            // Skeleton loader
            <>
              <ProjectRowSkeleton />
              <ProjectRowSkeleton />
              <ProjectRowSkeleton />
              <ProjectRowSkeleton />
              <ProjectRowSkeleton />
            </>
          ) : (
            results.map((item) => <Project key={item.id} item={item} />)
          )}
        </TableBody>

        <TableFooter timeTotal={timeTotal} alreadyPaid={alreadyPaid} />
      </div>
    </div>
  );
}

export default Developers;
